module.exports = __webpack_public_path__ + "img/99.3.aeba955b.png";